import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Logo from 'components/logo';
import LinkButton, {
  actionTypes as linkButtonActionTypes,
} from 'components/link-button';
import MainMenu from 'components/main-menu';
import useToggle from 'hooks/use-toggle';
import useEscape from 'hooks/use-escape';
import cn from 'classnames';
import FocusTrap from 'focus-trap-react';

const headerMenuId = 'header-menu';
const bodyActiveClass = 'header-menu-is-opened';

const Header = ({ logo, mainMenu, lang }) => {
  const {
    isActive: isMenuActive,
    toggle: toggleMenu,
    deactivate: deactivateMenu,
  } = useToggle(false);
  useEscape(deactivateMenu);

  useEffect(() => {
    if (isMenuActive) {
      document.body.classList.add(bodyActiveClass);
    } else {
      document.body.classList.remove(bodyActiveClass);
    }
  }, [isMenuActive]);

  return (
    <FocusTrap
      active={isMenuActive}
      focusTrapOptions={{
        clickOutsideDeactivates: true,
      }}
    >
      <div
        className={cn('header', {
          'header_menu-opened': isMenuActive,
        })}
      >
        <div className="header__container">
          <div className="header__content">
            {logo && logo.url && (
              <Logo {...logo} imageClass="image_size_header-logo" />
            )}
            <LinkButton
              onClick={toggleMenu}
              className="header__menu-button link-button_header-menu-button"
              text={isMenuActive ? lang.closeMenuLabel : lang.menuLabel}
              action={
                isMenuActive
                  ? linkButtonActionTypes.close
                  : linkButtonActionTypes.menu
              }
              ariaAttributes={{
                'aria-label': isMenuActive
                  ? lang.closeMenuLabel
                  : lang.menuLabel,
                'aria-haspopup': true,
                'aria-controls': headerMenuId,
              }}
            />
          </div>
        </div>
        {mainMenu && (
          <div
            className={cn('header__menu', {
              header__menu_opened: isMenuActive,
            })}
            id={headerMenuId}
            role="dialog"
            aria-hidden={!isMenuActive}
          >
            <div className="header__menu-container">
              <MainMenu {...mainMenu} navAriaLabel={lang.menuLabel} />
            </div>
          </div>
        )}
      </div>
    </FocusTrap>
  );
};

Header.propTypes = {
  logo: PropTypes.exact(Logo.propTypes),
  mainMenu: PropTypes.exact(MainMenu.propTypes),
  lang: PropTypes.shape({
    menuLabel: PropTypes.string.isRequired,
    closeMenuLabel: PropTypes.string.isRequired,
  }).isRequired,
};

export default Header;
